import { useSeo } from "../hooks/useSeo";

export default function Privacy() {
  useSeo({ title: "Privacy Policy — Practical AI for Everyday Life", description: "How we handle your information." });
  return (
    <section className="sheet">
      <div className="container-brand py-16">
        <p className="eyebrow">Legal</p>
        <h1 className="mt-3 text-4xl sm:text-5xl">Privacy Policy</h1>
        <div className="measure mt-8 space-y-5 text-text-body">
          <p className="text-sm text-text-muted">Last updated: {new Date().toLocaleDateString()}</p>
          <p>
            Practical AI for Everyday Life ("we", "us") respects your privacy. This page explains what we
            collect and how we use it, in plain English.
          </p>
          <h3 className="text-2xl">What we collect</h3>
          <p>
            When you join our email list, we collect the email address you give us. That's it. We don't ask
            for your name, phone number, or payment details.
          </p>
          <h3 className="text-2xl">How we use it</h3>
          <p>
            We use your email only to send you free AI setups, updates, and occasional notes from BJ. We will
            never sell or rent your information to anyone.
          </p>
          <h3 className="text-2xl">Unsubscribing</h3>
          <p>
            You can leave the list at any time using the unsubscribe link in any email. Once you unsubscribe,
            we remove you from our active mailing list.
          </p>
          <h3 className="text-2xl">Analytics</h3>
          <p>
            We may use privacy-friendly analytics to understand which guides are helpful. This data is
            aggregated and not used to identify you personally.
          </p>
          <h3 className="text-2xl">Contact</h3>
          <p>
            Questions? Email us at <a className="prose-link" href="mailto:hello@practicalaiforeverydaylife.com">hello@practicalaiforeverydaylife.com</a>.
          </p>
        </div>
      </div>
    </section>
  );
}
